import { Box, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Link } from 'react-router-dom';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.DOCUMENTS_HANDLE);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      mt={isDesktop ? '64px' : '48px'}
      gap={isDesktop ? '16px' : '12px'}
    >
      <Link to='/form' style={{ textDecoration: 'none', alignSelf: 'start' }}>
        <Box component={'span'} fontSize={'21px'}>
          ‹{' '}
        </Box>
        {dictionary.backToForm}
      </Link>
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: isDesktop ? '28px !important' : '22px !important',
        }}
      >
        {dictionary.title}
      </Typography>
      <Typography
        sx={
          isDesktop
            ? {
                fontSize: '18px !important',
              }
            : {
                fontSize: '16px !important',
                textAlign: 'left',
              }
        }
      >
        {dictionary.subTitle}
      </Typography>
    </Stack>
  );
};
